import { Controller } from '@hotwired/stimulus';

export class TriggerController extends Controller {
  static targets = ['element'];

  click() {
    this.elementTarget.click();
  }
}
